import { ConfigApi, useApi, configApiRef } from '@backstage/core-plugin-api';

export interface ProjectEnvMap {
  [projectName: string]: string[];
}

export function useProjectEnvMap(): ProjectEnvMap {
  const configApi: ConfigApi = useApi(configApiRef);
  const envMap = configApi.getOptionalString('dxmProjectEnvMap.config');

  return envMap ? JSON.parse(envMap) as ProjectEnvMap : {};
}

